export default __webpack_public_path__ + "static/media/O-113.5387944a.png";